import { Email } from 'src/app/model/email';
import Contact from 'src/app/model/Contact/contact';

export class ContactOption {
  id?: number;
  firstName?: string;
  lastName?: string;
  projectManager?: boolean;
  emails?: Email[];

  constructor(
    id?: number,
    projectManager?: boolean,
    firstName?: string,
    lastName?: string,
    emails?: Email[]
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.projectManager = projectManager;
    this.emails = emails;
  }

  public static fromContact(
    contact: Contact,
    projectManager?: boolean
  ): ContactOption {
    return new ContactOption(
      contact.id,
      projectManager,
      contact.firstName,
      contact.lastName,
      contact.emails
    );
  }
}
